import * as React from 'react';
import {
  InsightCardHorizontalBarGraphV2,
  HorizontalBarGraphItem,
} from '@leagueplatform/dashboard';

function generateAriaLabel(items: HorizontalBarGraphItem[]) {
  const ariaLabel = items
    .map((item) => `${item.label} ${item.displayValue}`)
    .join('; ');
  return ariaLabel;
}

type HorizontalBarGraphInsightResponse = {
  description: string;
  items: HorizontalBarGraphItem[];
};
export function HorizontalBarGraphNodeRenderer({
  description,
  items,
}: HorizontalBarGraphInsightResponse) {
  const ariaLabel = generateAriaLabel(items);

  return (
    <InsightCardHorizontalBarGraphV2
      title={description}
      description={ariaLabel}
      items={items}
    />
  );
}
